import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/employee-redux";
import { Container, Grid } from "semantic-ui-react";

import { taskActions } from "../taskActions";

import { ApplicationState } from "../../applicationState";
import { loadActionableTasks } from "../actions";

export const ActionableTaskList: React.FunctionComponent = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadActionableTasks());
    }, [dispatch]);

    const actionableTasks = useSelector((state: ApplicationState) => state.actionableTasks.sort((a, b) => -a.dateCreated.diff(b.dateCreated))) ?? [];

    return (
        <Container className="actionable-task-list">
            <Grid verticalAlign="middle">
                <Grid.Row>
                    <h1>Outstanding Actions</h1>
                </Grid.Row>
                {actionableTasks.map(task => (
                    <Grid.Row key={task.id} className="actionable-task-row">
                        <Grid.Column computer={12} tablet={8} mobile={8}>
                            <strong>{task.description}</strong>
                        </Grid.Column>
                        <Grid.Column computer={4} tablet={8} mobile={8} textAlign="right">
                            {task.actions && task.actions
                                .filter(a => taskActions[a])
                                .map(a => <React.Fragment key={a}>{taskActions[a](task)}</React.Fragment>)}
                        </Grid.Column>
                    </Grid.Row>
                ))}
            </Grid>
        </Container>
    );
};
